import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { FaShoppingCart } from 'react-icons/fa';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCartShopping } from '@fortawesome/free-solid-svg-icons';

import './App.css';

function App() {
  const images = ['/sweter1.jpg', '/czapka.jpg', '/torba.jpg'];
  const labels = ['SWETRY', 'CZAPKI', 'TORBY'];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    document.title = 'Cozy Fang';
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = '/logo.png';
    favicon.type = 'image/png';
    document.head.appendChild(favicon);

    return () => {
      document.head.removeChild(favicon);
    };
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="App">
      <header className="App-header">
  <div className="navbar">
    <div className="logo">
      <img src="/logo.png" alt="logo" />
    </div>
    <div className="brand-name">Cozy Fang</div>
    <nav>
      <ul className="menu">
        <li className="home"><Link to="/">Home</Link></li>
        <li><Link to="/store">Store</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
    </nav>
  </div>
</header>

      <div className="Main">
        <div
          className="pictures"
          key={currentIndex}
          style={{ backgroundImage: `url(${images[currentIndex]})` }}
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            if (clickX < rect.width / 2) {
              handlePrev();
            } else {
              handleNext();
            }
          }}
        >
          <div className="nav-arrow left" onClick={handlePrev}>
            <span>&#8592;</span>
          </div>
          <div className="nav-arrow right" onClick={handleNext}>
            <span>&#8594;</span>
          </div>
          <button
              className="check-button"><span><Link to="/store">Sprawdź</Link></span>
           </button>
          <div className="image-label">{labels[currentIndex]}</div>
        </div>
      </div>
      <div className="Footer">
        <img src="/logo.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          COZY FANG 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">REGULAMIN</a>
          <a href="/polityka-prywatnosci">POLITYKA PRYWATNOŚCI</a>
        </div>
      </div>
    </div>
  );
}

export default App;
